import React from "react";
import {DertigenEvent} from "../../model/DertigenEvent";
import FutureDoublerMoveBadge, {getDisplayedStripes} from "./FutureDoublerMoveBadge";

export const getMoveSummary = (move: DertigenEvent): string => {
    if (move.doubler) {
        return 'Verdubbelaar';
    }

    if (move.drinkingMove) {
        return `+${move.gulps ?? 0} gedronken`;
    }

    return `+${getDisplayedStripes(move)} strepen`;
};

interface DertigenMoveSummaryProps {
    move: DertigenEvent;
}

const DertigenMoveSummary: React.FC<DertigenMoveSummaryProps> = ({move}) => (
    <>
        <span>{getMoveSummary(move)}</span>
        <FutureDoublerMoveBadge move={move}/>
    </>
);

export default DertigenMoveSummary;
